import { inject, Injectable } from '@angular/core';
import { navigateFn } from '@softline/application';
import { modalFn } from '@softline/ui-core';
import { DocumentCreationWizardComponent } from '../components/document-creation-wizard/document-creation-wizard.component';
import { formDataToCreateRequest } from '../helper/document-form/form-data-to-create-request';
import { SalesDocumentService } from './sales-document.service';

@Injectable({ providedIn: 'root' })
export class SalesQuickCreateService {
  private readonly navigate = navigateFn();
  private readonly documentService = inject(SalesDocumentService);
  private readonly modal = modalFn();

  async createDocument(documentTypeCode?: string | null): Promise<void> {
    const result = await this.modal({
      component: DocumentCreationWizardComponent,
      title: 'Beleg erstellen',
      subtitle:
        'Bitte wählen Sie die gewünschten Optionen aus, um den Beleg zu erstellen.',
      icon: 'fa-regular fa-file-circle-plus',
      separateContentSection: true,
      surfaceControls: { minimize: true, dock: true },
    });

    if (!result || result === 'DISMISSED') return;

    this.documentService.setDocumentData(result);
    const created = await this.documentService.create(
      formDataToCreateRequest(result, documentTypeCode, 'create')
    );
    if (!created) return;
    await this.navigate(['/sales/document', created.id], { origin: true });
  }
}
